<template>
  <div class="theory">
    <!-- 导航 -->
    <headerTemplate title="理论考试"></headerTemplate>
    <div class="theory-status">
      <div class="theory-status-item" v-if="pageList.alog_store_name">
        <span class="label">用户姓名:</span>
        <span class="content">{{pageList.alog_store_name}}</span>
      </div>
      <div class="theory-status-item">
        <span class="label">上次考试成绩:</span>
        <span class="content">{{pageList.score}}</span>
      </div>
      <div class="theory-status-item">
        <span class="label">最好考试成绩:</span>
        <span class="content">{{pageList.high_score}}</span>
      </div>
      <div class="theory-status-item">
        <span class="label">作答次数:</span>
        <span class="content">{{pageList.score_num}}</span>
      </div>
      <div class="theory-status-item">
        <span class="label">最后答题时间:</span>
        <span class="content">{{pageList.edit_time}}</span>
      </div>
      <div class="theory-status-item">
        <span class="label">当前状态:</span>
        <span class="content" v-if="pageList.status == 0">未作答</span>
        <span class="content" v-if="pageList.status == 1">可以继续参加考试</span>
        <span class="content" v-if="pageList.status == 2">已完成</span>
      </div>
    </div>
    <!-- 试题 -->
    <div class="theory-test">
      <div class="sumbit-icon">
        <van-button v-if="finishSta" type="info" size="small" @click="changeFinishSta">再做一次</van-button>
        <van-button v-else type="info" size="small" @click="submitPage">交卷</van-button>
      </div>
      <div class="single-choice">
        <div class="single-title">一.单项选择题</div>
        <div class="single-choice-item" v-for="(item, i) in pageContent.single" :key="i">
          <div class="question-title">{{item.num}}、{{item.question_title}}</div>
          <div class="select-box">
            <van-radio-group v-model="single[i]" v-for="(q,t) in item.chose" :key="t" class="select-box-item">
              <van-radio :disabled="finishSta ? true : false" :name="item.question_id + ',' + q.chose_num">
                {{q.chose_id}} {{q.chose}}</van-radio>
            </van-radio-group>
          </div>
          <!-- 答案区 -->
          <div v-if="finishSta" class="answer-wapper">
            <div class="right-answer" v-if="isRight(item,1)">
              <span>回答正确：
                <van-icon name="success" class="answer-right" />
              </span>
            </div>
            <div class="wrong-answer" v-else>
              <p>回答错误：
                <van-icon name="cross" color="#ff0000" />
              </p>
              <p>您的答案：<span>{{ yourAnswer(item,1)}}</span></p>
              <p>正确答案是：<span style="color: #eed1d1;">{{ rightAnswer(item,1)}}</span></p>
            </div>
          </div>
        </div>
      </div>
      <div class="multiple-choice">
        <div class="multiple-title">二.多项选择题</div>
        <div class="multiple-choice-item" v-for="(item, i) in pageContent.multiple" :key="i">
          <div class="question-title">{{item.num}}、{{item.question_title}}</div>
          <van-checkbox-group v-model="multiple[i]" class="select-box">
            <van-checkbox class="select-box-item" :disabled="finishSta ? true : false"
              :name="item.question_id + ',' + q.chose_num" shape="square" v-for="(q,qi) in item.chose" :key="qi">
              {{q.chose_id}} {{ q.chose }}</van-checkbox>
          </van-checkbox-group>
          <!-- 答案div -->
          <div v-if="finishSta" class="answer-wapper">
            <div class="right-answer" v-if="isRight(item,2)">
              <span>回答正确：
                <van-icon name="success" class="answer-right" />
              </span>
            </div>
            <div v-else class="wrong-answer">
              <p>回答错误：
                <van-icon name="cross" color="#ff0000" />
              </p>
              <!-- <p>您的答案：<span>{{ toLetter3(multiple[i]) }}</span></p>
              <p>正确答案是：<span style="color: #ff0000;">{{ toLetter2(item.answer) }}</span></p> -->
              <p>您的答案：<span>{{ yourAnswer(item,2)}}</span></p>
              <p>正确答案是：<span style="color: #eed1d1;">{{ rightAnswer(item,2)}}</span></p>
            </div>
          </div>
        </div>
      </div>
      <div class="judge-choice">
        <div class="judge-title">三.判断对错</div>
        <div class="judge-choice-item" v-for="(item, i) in pageContent.judge" :key="i">
          <div class="question-title">{{item.num}}、{{item.question_title}}</div>
          <van-radio-group v-model="judge[i]" class="select-box">
            <van-radio :disabled="finishSta ? true : false" :name="item.question_id + ',' + q.chose_num"
              v-for="(q,qi) in item.chose" :key="qi" class="select-box-item">{{q.chose_id}} {{q.chose}}</van-radio>
          </van-radio-group>
          <!-- 答案div -->
          <div v-if="finishSta" class="answer-wapper">
            <div class="right-answer" v-if="isRight(item,3)">
              <span>回答正确：
                <van-icon name="success" class="answer-right" />
              </span>
            </div>
            <div class="wrong-answer" v-else>
              <p>回答错误：
                <van-icon name="cross" color="#ff0000" />
              </p>
              <!-- <p>您的答案：<span>{{ toChinese(!item.answer) }}</span></p>
              <p>正确答案是：<span style="color: #ff0000;">{{ toChinese(item.answer) }}</span></p> -->

              <p>您的答案：<span>{{ yourAnswer(item,3)}}</span></p>
              <p>正确答案是：<span style="color: #eed1d1;">{{ rightAnswer(item,3)}}</span></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import headerTemplate from '@/components/headerTemplate/headerTemplate'
  import { submitPage, getPage } from '../../../api/student'
  export default {
    name: 'Theory',
    components: {
      headerTemplate
    },
    props: [],
    data() {
      return {
        // 是否交过卷
        finishSta: false,
        // 单项选择
        single: [],
        // 多项选择
        multiple: [],
        // 对错
        judge: [],
        // 当前试卷的id
        pageId: 1,
        // 试卷内容
        pageList: {},
        // 试卷题目内容
        pageContent: {}
      }
    },
    methods: {
      // 回到首页
      goBack() {
        this.$router.go(-1)
      },
      yourAnswer(object, type) {
        let letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G']
        let tag = "";
        let tagAr = []
        let array = object.chose
        for (let index = 0; index < array.length; index++) {
          let user_answer = object.user_answer
          const chose = array[index];
          if (type == 1 || type == 3) {
            if (chose.chose_num == user_answer) {
              tag = letters[index]
            }
          }
          if (type == 2) {
            if (user_answer) {
              user_answer = user_answer.split(',')
              user_answer.sort((a, b) => {
                return a - b
              })
              user_answer.forEach(element => {
                if (element == chose.chose_num) {
                  tagAr.push(letters[index])
                }
              });
              tag = tagAr.toString()
            }
          }
        }
        return tag
      },
      rightAnswer(object, type) {
        let letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G']
        let tagAr = []
        let tag = ""
        let array = object.chose
        let answer = object.answer
        for (let index = 0; index < array.length; index++) {
          let user_answer = object.user_answer
          const chose = array[index];
          if (type == 1 || type == 3) {
            if (chose.chose_num == answer) {
              tag = letters[index]
            }
          }
          if (type == 2) {
            if (answer) {
              answer = object.answer.split(',')
              if (answer.includes(chose.chose_num.toString())) {
                tagAr.push(letters[index])
              }
              tag = tagAr.toString()
            }
          }
        }
        return tag
      },
      isRight(object, type) {
        let user_answer = object.user_answer
        if (type == 1 || type == 3) {
          return object.answer == user_answer
        }
        if (type == 3) {
          if (user_answer) {
            user_answer = user_answer.split(',')
            return user_answer.every((item) => {
              return object.answer.split(',').includes(item)
            })
          } else {
            return false
          }
        }
      },
      // toChinese(answer) {
      //   return answer == 1 ? '正' : '错'
      // },
      // yourAnswer(answer) {
      //   let letters = ['', 'A', 'B', 'C', 'D', 'E', 'F', 'G']
      //   return letters[answer]
      // },
      // toLetter2(answer) {
      //   let letters = ['', 'A', 'B', 'C', 'D', 'E', 'F', 'G']
      //   let newAnswer = []
      //   let answerArr = answer.split(",")
      //   for (let i = 0; i < answerArr.length; i++) {
      //     newAnswer.push(letters[answerArr[i]])
      //   }
      //   return newAnswer.join(',')
      // },
      // toLetter3(answer) {
      //   let letters = ['', 'A', 'B', 'C', 'D', 'E', 'F', 'G']
      //   let newAnswer = []
      //   for (let i = 0; i < answer.length; i++) {
      //     newAnswer.push(letters[answer[i].substr(-1)])
      //   }
      //   return newAnswer.join(',')
      // },
      // 改变做卷状态
      changeFinishSta() {
        this.finishSta = !this.finishSta
      },
      // 提交试卷
      submitPage() {
        this.changeFinishSta()
        submitPage({
          paper_id: this.pageId,
          single: this.single.toString(),
          judge: this.judge.toString(),
          multiple: this.multiple.toString(),
        }).then(res => {
          if (res.code === 10000) {
            this.getPage()
          }
        }).catch(error => {
          this.$router.push('Home')
        })
      },
      strToArr(str) {
        let arr = str.split(',')
        let res = []
        for (let i = 0; i < arr.length; i += 2) {
          res.push(arr[i] + ',' + arr[i + 1])
        }
        return res
      },
      getPage() {
        getPage(this.pageId).then(res => {
          // 试卷整体内容
          this.pageList = res.result
          // 试卷选择题，判断题
          let paper = res.result.paper

          let num = 0;

          let keys = ['single', 'multiple', 'judge']
          keys.forEach((key) => {
            let array = paper[key];
            for (let index = 0; index < array.length; index++) {
              const element = array[index];
              num += 1;
              paper[key][index]["num"] = num
            }
          })

          this.pageContent = paper
          if (res.result.status == 1) {
            const answer = JSON.parse(res.result.answer)
            this.finishSta = true
            this.single = this.strToArr(answer.single)
            this.multiple = [this.strToArr(answer.multiple)]
            this.judge = this.strToArr(answer.judge)
          }
        })
      }
    },
    created() {
      this.getPage()
    }
  }
</script>

<style lang="scss" scoped>
  .theory {
    font-size: 14px;
    background: white;

    .theory-title {
      display: flex;
      align-items: center;
      color: white;

      .title {
        padding: 10px;
        font-size: 14px;
      }
    }

    .theory-status {
      margin: 5px 10px;
      box-shadow: 0 0 5px #bbb7b7;
      padding: 10px 0;

      .theory-status-item {
        padding: 5px;
        display: flex;
        align-items: center;
      }
    }

    .theory-test {
      margin: 5px 10px;
      padding-bottom: 5rem;

      .sumbit-icon {
        margin: 10px 0px;
      }

      .single-choice,
      .multiple-choice,
      .judge-choice {

        .single-title,
        .multiple-title,
        .judge-title {
          background: #e0e0e0;
          color: black;
          font-size: 16px;
          padding: 10px;
        }

        .single-choice-item,
        .multiple-choice-item,
        .judge-choice-item {
          margin: 10px 0;
          padding: 5px;
          box-shadow: 0 0 5px #bbb7b7;
        }
      }
    }
  }

  .question-title {
    padding: 5px;
  }

  .answer-wapper {
    line-height: 22px;
    padding: 10px 0;
  }

  .select-box {
    display: flex;
    flex-direction: column;

    .select-box-item {
      padding: 5px 0;
    }
  }

  .answer-right {
    color: blue;
    font-size: 16px;
  }
</style>